// data/alloysCategories.js
const alloysCategories = [
    { id: 1, name: 'С высоким электросопротивлением', path: '/splavi/high-resistance' },
    { id: 2, name: 'Стали и сплавы для сварки', path: '/splavi/welding-materials' },
    { id: 3, name: 'Прецизионные магнитно-мягкие', path: '/splavi/soft-magnetic' },
    { id: 4, name: 'Магнитно-мягкие с высокой магнитной индукцией', path: '/splavi/high-induction' },
    { id: 5, name: 'Прецизионные магнитотвердые', path: '/splavi/hard-magnetic' },
    { id: 6, name: 'Для упругих элементов', path: '/splavi/elastic' },
    { id: 7, name: 'С заданным ТКЛР', path: '/splavi/tclr' },
    { id: 8, name: 'Жаропрочные сплавы', path: '/splavi/heat-resistant-alloys' },
    { id: 9, name: 'Стали специальные коррозионностойкие', path: '/splavi/corrosion-resistant' },
]

export default alloysCategories;